import React from 'react';
import ReactDOM from 'react-dom/client';
import './aws-exports'; // Configure Amplify before anything else
import './index.css';
import './print-root.css'; // IDI-333: shared print-isolation mechanism — see file docblock
import './build-sha.css'; // §C-10 canary — SHA embedded at build time (scripts/emit-build-sha-css.js)
import App from './App';
import reportWebVitals from './reportWebVitals';
import { reportGlobalErrors } from './hooks/useTelemetry';

// IDI-303: catch errors React's own error boundaries never see — an event
// handler that throws outside a render, or a rejected Promise nobody
// awaited/caught. Must run before the app renders so nothing in the early
// boot path is missed.
reportGlobalErrors();

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// §3c reverted — redeploy trigger
